import PropTypes from 'prop-types'
import InfiniteScroll from '../../infinite-scroll/InfiniteScroll'

import classes from './FamiliesTable.module.scss'
import Loader from '../../common/loader/Loader'
import StudentWithAvatar from '../../students/StudentWithAvatar'
import { useNavigate } from 'react-router-dom'
import classNames from 'classnames'
import { displayWithCurrency } from '../../../utility/currency'
import { useSelector } from 'react-redux'


const FamiliesTable = ({ families, fetchData, pagination }) => {
  const navigate = useNavigate()
  const hasMore = !pagination?.totalPages || (pagination?.page + 1) <= pagination?.totalPages
  const currency = useSelector(state => state.user.current_user.communities[0].currency)


  if (!families || !pagination) {
    return (
      <div className='h-100 d-flex align-items-center justify-content-center'>
        <Loader>Loading Families</Loader>
      </div>
    )
  }

  return (
    <div id='familiesTable' className={classes.table}>
      <div id='tableContent' className={classes.tableContent}>
        <InfiniteScroll
          dataLength={families.length}
          next={fetchData}
          hasMore={hasMore}
          scrollableTarget='tableContent'
          className={classes.tableContent}
        >
          <div className={classes.gridTable}>
            {families.map(family => (
              <div
                tabIndex={0}
                role='button'
                onKeyDown={() => null}
                key={family.id}
                className={classes.row}
                onClick={() => navigate(`/members/families/${family.id}`, { state: { from: 'members-families-page' } })}
              >
                <div className={classNames(classes.col, classes.familyTitle)}>
                  <h5 className='font-weight-bold'>{family.name}</h5>
                  {family.familyAdmins?.[0] && (
                    <div className={classes.familyAdmin}>
                      <span className='font-weight-bold'>{family.familyAdmins[0].firstName} {family.familyAdmins[0].lastName}</span>
                      <span>|</span>
                      <span>{family.familyAdmins[0].email}</span>
                      <span>|</span>
                      <span>{family.familyAdmins[0].phonePrefix}{family.familyAdmins[0].phone}</span>
                    </div>
                  )}
                </div>

                <div className={classNames(classes.col, classes.totalRevenue)}>
                  <span>{family.revenue > 0 ? displayWithCurrency(family.revenue, currency, true) : '-'}</span>
                  <span>Total Revenue</span>
                </div>

                <div className={classNames(classes.col, classes.membersCount)}>
                  <span>{family.users.length} members</span>
                </div>

                <div className={classNames(classes.col, classes.members)}>
                  {family.users.map((student, idx) => (
                    <div
                      key={student.id}
                      className={classes.avatar}
                      style={{ zIndex: 50 - idx, marginLeft: idx === 0 ? 0 : '-16px' }}
                    >
                      <StudentWithAvatar student={student} />
                    </div>
                  ))}
                </div>

                <div className={classNames(classes.col, classes.viewDetailsButton)}>
                  <button
                    className='btn btn-primary text-white'
                  >
                    View Details
                  </button>
                </div>
              </div>
            ))}
          </div>
        </InfiniteScroll>
      </div>
    </div>
  )
}

FamiliesTable.propTypes = {
  families: PropTypes.array,
  fetchData: PropTypes.func.isRequired,
  pagination: PropTypes.object,
}

export default FamiliesTable
